module.exports = __webpack_public_path__ + "img/logo-malha-fina.92881973.png";